import React, { useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import PropTypes from 'prop-types';

// Styles
import { Container, Table, Tbody, Tr, Td, Button } from './styles';

function SchedulerByEmployees({
  begin,
  end,
  equipments,
  toggle,
  onEdit,
  holidays,
  extraDays,
}) {
  const [period, setPeriod] = useState([]);
  const [schedule, setSchedule] = useState([]);

  useEffect(() => {
    const periodTime = moment(end).diff(begin, 'days');
    const periodArray = [];
    let scheduleArray = [];
    const weekdays = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB'];

    // eslint-disable-next-line no-plusplus
    for (let index = 0; index <= periodTime; index++) {
      const date = moment(begin).add(index, 'days');
      const weekday =
        weekdays[new Date(moment(date).format('MM/DD/YYYY')).getDay()];

      const day = {
        date,
        weekday,
        weekdayindex: new Date(moment(date).format('MM/DD/YYYY')).getDay(),
      };
      periodArray.push(day);
    }

    // get employees list
    let employeesList = {};
    equipments.forEach(equipment => {
      const {
        uuid: equipmetUuid,
        code: equipmentCode,
        serviceequipments,
      } = equipment;

      serviceequipments.forEach(item => {
        const { service, serviceequipmentemployees } = item;
        const {
          uuid: serviceUuid,
          opening_date: begin,
          closing_date: end,
          partner,
          type,
          observation,
          baseUuid,
          weekly_frequency,
          serviceextradays,
        } = service;

        let currentService = {
          serviceUuid,
          begin,
          end,
          partner,
          type,
          observation,
          baseUuid,
          weekly_frequency,
          serviceextradays,
        };

        serviceequipmentemployees.forEach(employeeItem => {
          const { employee, description } = employeeItem;
          const { uuid: employeeUuid, name } = employee;

          if (!employeesList[employeeUuid]) {
            employeesList[employeeUuid] = {
              uuid: employeeUuid,
              name: name,
              services: [],
            };
          }

          employeesList[employeeUuid].services.push(
            (currentService = {
              ...currentService,
              description: description,
              equipment: {
                uuid: equipmetUuid,
                code: equipmentCode,
              },
            })
          );
        });
      });
    });
    employeesList = Object.values(employeesList);

    employeesList.sort((previous, next) => {
      const namePrevious = previous.name.toUpperCase();
      const nameNext = next.name.toUpperCase();

      if (namePrevious < nameNext) {
        return -1;
      }
      if (namePrevious > nameNext) {
        return 1;
      }
      return 0;
    });

    employeesList.forEach(employeeItem => {
      const scheduleItem = {
        name: employeeItem.name,
        services: [],
      };

      scheduleItem.services = employeeItem.services.map(item => {
        const {
          serviceUuid,
          begin,
          end,
          partner,
          type,
          observation,
          description,
          equipment,
          baseUuid,
          weekly_frequency,
          serviceextradays,
        } = item;

        let string = '';

        if (equipment) {
          string += `<br />Equipamento: ${equipment.code} <br />`;
        }

        if (description) {
          string += `<br />Descrição: ${description} <br />`;
        }

        if (observation) {
          string += `<br />Observação: <br />${observation}`;
        }

        const data_tip = `
        ${partner.name}
        <br />
        ${string}`;

        return {
          serviceUuid,
          begin: moment(begin),
          end: moment(end).add(1, 'days'),
          partner_name: partner.name,
          data_tip,
          type: type,
          baseUuid,
          weekly_frequency,
          serviceextradays,
        };
      });

      scheduleArray.push(scheduleItem);
    });

    setPeriod(periodArray);
    setSchedule(scheduleArray);
  }, [begin, end, toggle, equipments]);

  const handleItemSelect = uuid => {
    let selectedItem = null;

    equipments.forEach(equipment => {
      const serviceequipment = equipment.serviceequipments.find(
        item => item.service.uuid === uuid
      );

      if (serviceequipment) {
        selectedItem = {
          equipment,
          serviceequipment,
          baseUuid: serviceequipment.service.baseUuid,
        };
      }
    });

    onEdit(
      selectedItem.equipment,
      selectedItem.serviceequipment,
      selectedItem.baseUuid
    );
  };

  const handleServicesRow = (item, serviceIndex) => {
    const service = item ? item : null;
    const list = [];
    let index = 0;
    let countButtons = 0;
    const holidaysDates = holidays.map(holiday =>
      moment(holiday.date).format('YYYY-MM-DD')
    );
    const extraDaysDates = item?.serviceextradays.map(extraDay =>
      moment(extraDay.extraDay).format('YYYY-MM-DD')
    );

    while (index < period.length) {
      const targetDate = moment(period[index].date).format('YYYY-MM-DD');
      let targetDateHolidays = holidays.filter(
        holiday => moment(holiday.date).format('YYYY-MM-DD') === targetDate
      );
      let isHoliday = holidaysDates.includes(targetDate);
      let isExtraDay = extraDaysDates.includes(targetDate);
      if (isExtraDay) {
        isHoliday = false;
      } else {
        if (isHoliday) {
          targetDateHolidays.forEach(holiday => {
            if (!holiday.baseUuid) {
              isHoliday = true;
            } else if (holiday.baseUuid !== service.baseUuid) {
              isHoliday = false;
            }
          });
        }
      }

      if (
        service &&
        moment(period[index].date).isBetween(service.begin, service.end)
      ) {
        list.push(
          <Td colSpan={1} data-html="true" data-tip={service.data_tip}>
            <Button
              serviceType={service.type}
              currentDate={period[index].weekdayindex}
              weeklyFrequency={service.weekly_frequency}
              isHoliday={isHoliday}
              isExtraDay={isExtraDay}
              type="button"
              onClick={() => handleItemSelect(service.serviceUuid)}
            >
              <strong>
                {countButtons === 0
                  ? `${service.partner_name.substring(0, 16)}${
                      service.partner_name.length >= 16 ? '...' : ''
                    }`
                  : ''}
              </strong>
            </Button>
          </Td>
        );
        countButtons++;
        index++;
      } else {
        list.push(<Td>-</Td>);
        // eslint-disable-next-line no-plusplus
        index++;
      }
    }

    return list;
  };

  return (
    <Container>
      <Table>
        <Tbody>
          <Tr>
            <Td />
            {period.map(day => (
              <Td key={day.date.format('DD/MM')} style={{ width: '130px' }}>
                <div>
                  <small>{day.weekday}</small>
                  <strong>{day.date.format('DD/MM')}</strong>
                </div>
              </Td>
            ))}
          </Tr>
          {schedule.map(item => (
            <>
              <Tr>
                <Td rowSpan={item.services.length + 1} className="equipment">
                  <div>{item.name}</div>
                </Td>
              </Tr>
              {item.services &&
                item.services[0] &&
                item.services.map((service, index) => (
                  <Tr>{handleServicesRow(service, index)}</Tr>
                ))}
              <ReactTooltip type="info" effect="float" place="bottom" />
            </>
          ))}
        </Tbody>
      </Table>
    </Container>
  );
}

SchedulerByEmployees.propTypes = {
  begin: PropTypes.string,
  end: PropTypes.string,
  toggle: PropTypes.string,
  equipments: PropTypes.arrayOf(PropTypes.shape({})),
  onEdit: PropTypes.func.isRequired,
  holidays: PropTypes.arrayOf(PropTypes.shape({})),
  serviceExtraDays: PropTypes.arrayOf(PropTypes.shape({})),
};

SchedulerByEmployees.defaultProps = {
  begin: null,
  end: null,
  toggle: 'employees',
  equipments: [],
  holidays: [],
  serviceExtraDays: [],
};

export default SchedulerByEmployees;

